import { API } from ".";
import { logout, retryFetchSession } from "./session";

export const GET_SITE_DETAILS_REQUEST = "@@site/GET_SITE_DETAILS_REQUEST";
export const GET_SITE_DETAILS_SUCCESS = "@@site/GET_SITE_DETAILS_SUCCESS";
export const GET_SITE_DETAILS_FAILURE = "@@site/GET_SITE_DETAILS_FAILURE";

export function getSiteDetails(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_SITE_DETAILS_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/site/${id}`);
      dispatch({
        type: GET_SITE_DETAILS_SUCCESS,
        payload: response,
      });
    } catch (error) {
      if (error?.response?.statusCode === 401 || error?.$metadata?.httpStatusCode === 401 || error?.status === 401) {
        dispatch(retryFetchSession());
      } else if (error?.name === "InvalidApiName") {
        console.error("InvalidApiName error. Logging out.")
        dispatch(logout());
      }
      dispatch({
        type: GET_SITE_DETAILS_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_SITES = "@@site/CLEAR_SITES";

export function clearSites() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_SITES,
    });
  };
}
